var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmartphone = function SvgSmartphone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 70,
    viewBox: "0 0 46 70",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 8.08317C0.833496 3.71091 4.37791 0.166504 8.75016 0.166504H37.2502C41.6224 0.166504 45.1668 3.71092 45.1668 8.08317V61.9165C45.1668 66.2888 41.6224 69.8332 37.2502 69.8332H8.75016C4.37791 69.8332 0.833496 66.2888 0.833496 61.9165V8.08317ZM8.75016 6.49984C7.87571 6.49984 7.16683 7.20872 7.16683 8.08317V61.9165C7.16683 62.791 7.87571 63.4998 8.75016 63.4998H37.2502C38.1246 63.4998 38.8335 62.791 38.8335 61.9165V8.08317C38.8335 7.20872 38.1246 6.49984 37.2502 6.49984H8.75016Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 60.333C25.6234 60.333 27.75 58.2064 27.75 55.583C27.75 52.9597 25.6234 50.833 23 50.833C20.3766 50.833 18.25 52.9597 18.25 55.583C18.25 58.2064 20.3766 60.333 23 60.333Z",
    fill: "#8290A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 12.8332C16.667 11.0843 18.0848 9.6665 19.8337 9.6665H26.167C27.9159 9.6665 29.3337 11.0843 29.3337 12.8332C29.3337 14.5821 27.9159 15.9998 26.167 15.9998H19.8337C18.0848 15.9998 16.667 14.5821 16.667 12.8332Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmartphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smartphone.b15a6cf7.svg";
export { ForwardRef as ReactComponent };